"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordBodyToJSON = exports.ResetPasswordBodyFromJSONTyped = exports.ResetPasswordBodyFromJSON = void 0;
function ResetPasswordBodyFromJSON(json) {
    return ResetPasswordBodyFromJSONTyped(json, false);
}
exports.ResetPasswordBodyFromJSON = ResetPasswordBodyFromJSON;
function ResetPasswordBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'verificationCode': json['verificationCode'],
        'newPassword': json['newPassword'],
        'confirmPassword': json['confirmPassword'],
    };
}
exports.ResetPasswordBodyFromJSONTyped = ResetPasswordBodyFromJSONTyped;
function ResetPasswordBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'verificationCode': value.verificationCode,
        'newPassword': value.newPassword,
        'confirmPassword': value.confirmPassword,
    };
}
exports.ResetPasswordBodyToJSON = ResetPasswordBodyToJSON;
